// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const DailyJayLogo = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 220 102"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M151.731 23.937c0-7.73-5.863-10.152-11.639-10.152h-7.357v20.42h7.587c5.604 0 11.409-3.086 11.409-10.268Zm-5.116 0c0 4.557-3.247 6-6.753 6h-2.328V17.995h2.443c3.391 0 6.638 1.355 6.638 5.941ZM174.819 34.205l-8.449-20.42h-4.77l-8.535 20.42h5.345l1.494-4.01h7.874l1.581 4.01h5.46Zm-8.392-7.96h-5.115l2.587-7.01 2.528 7.01ZM182.88 34.205v-20.42h-4.943v20.42h4.943ZM200.478 34.205v-4.298h-7.874V13.785h-4.943v20.42h12.817ZM219.709 13.785h-5.747l-4.339 7.556-4.34-7.556h-5.948l7.644 11.767v8.653h4.914v-8.653l7.816-11.767ZM131.586 86.522c10.435 0 14.862-6.514 14.862-16.506V40.735h-13.597v28.08c0 2.972-.253 4.616-2.087 4.616-1.139 0-1.898-1.265-2.277-2.972l-10.878 4.932c1.455 6.451 7.147 11.13 13.977 11.13ZM173.158 85.51h14.355l-10.624-44.775h-17.012L149.316 85.51h13.723l1.202-6.198h7.715l1.202 6.198Zm-5.186-31.368h.253l2.087 14.546h-4.554l2.214-14.546ZM208.428 70.775l11.573-30.04h-14.609l-3.541 16.506h-.19l-3.352-16.506h-14.862l11.447 30.04V85.51h13.534V70.775Z"
			fill="#fff"
		/>
		<path
			d="M78.048 0H23.04C10.316 0 0 10.316 0 23.04v55.008c0 12.725 10.316 23.04 23.04 23.04h55.008c12.725 0 23.04-10.315 23.04-23.04V23.04C101.088 10.316 90.773 0 78.048 0Z"
			fill="url(#DailyJayLogo_tsx__a)"
		/>
		<path
			d="M78.048 0H23.04C10.316 0 0 10.316 0 23.04v55.008c0 12.725 10.316 23.04 23.04 23.04h55.008c12.725 0 23.04-10.315 23.04-23.04V23.04C101.088 10.316 90.773 0 78.048 0Z"
			fill="url(#DailyJayLogo_tsx__b)"
		/>
		<path
			d="M94.874 63.087a.61.61 0 0 0-.832-.237c-.645.358-2.784 1.07-3.458 1.315-2.535.414-5.65.32-7.157-3.39a13.694 13.694 0 0 0-1.702-3.176c-.893-1.194-3.808-2.614-6.531-.052a9.998 9.998 0 0 0-1.68 2.079c-.185.294-.355.587-.516.881l-.034-.116c-.238-.83-1.01-3.892-4.208-4.392-.44-.034-2.222-.234-4.685 2.467a23.58 23.58 0 0 0-2.26 2.941 4.743 4.743 0 0 0-.403-1.265c-2.095-3.22-5.274-.648-6.63.313-3.058 2.15-4.478 5.04-6.343-1.526a28.393 28.393 0 0 1-.58-2.825c1.861-3.156 5.65-12.761 3.473-19.21-.143-.407-.9-2.486-2.716-2.354-.26.027-2.331-.192-3.465 5.594-1.058 5.593-.825 12.806-.569 15.194.03.245.083.735.181 1.375-1.789 3.066-4.143 6.55-5.578 6.712-1.86.211-1.341-1.507-2.478-5.318-.196-.494-.825-2.852-3.65-2.735-1.383.06-2.848.418-4.844 2.603-3.243 3.548-10.645 8.885-15.937 5.53-.572-.445-3.431-2.78-2.38-9.794a22.638 22.638 0 0 1 1.699-5.586 24.774 24.774 0 0 1 2.904-4.897c5.438-6.674 10.147-7.454 11.077-7.416 2.38 0 3.013 3.085 3.013 3.059a.987.987 0 1 0 1.963-.193 5.442 5.442 0 0 0-.403-1.94 5.903 5.903 0 0 0-2.072-2.757c-2.994-2.045-9.721-.376-16.268 7.157a26.449 26.449 0 0 0-3.416 5.56 25.614 25.614 0 0 0-1.981 6.493c-1.763 12.43 5.796 14.392 7.085 14.633 6.625.773 11.503-2.832 13.808-5.043.832 4.143 4.976 4.192 6.78 2.324a6.281 6.281 0 0 0 1.13-1.676c1.077 3.917 4.52 2.584 4.934 2.41 1.925-.723 3.936-3.39 5.36-5.65.904 3.082 2.637 6.381 6 6.027 2.023-.049 7.085-5.431 7.556-4.727.467.58.591 1.646.561 3.24-.03 1.593 1.232 1.672 1.804 1.506.886-.245 1.443-1.989 2.37-3.507a15.591 15.591 0 0 1 1.988-2.636c.377-.377 2.008-2.09 3.168-1.507 1.16.584 1.277 1.767 1.356 2.422.08.655.09 1.356.12 2.12-.033 2.637 1.206 3.014 1.553 3.104 2.866.776 3.047-4.61 5.148-6.61.196-.204 2.034-2.102 3.082.994 1.506 5.59 6.18 7.68 12.456 4.573a9.648 9.648 0 0 0 2.03-1.277.614.614 0 0 0 .177-.814Zm-61.396-1.13c-1.254 2.577-4.011 2.422-3.974-.376.042-2.878 3.624-4.686 4.584-2.682.079.17.14.348.185.531a12.05 12.05 0 0 1-.806 2.524l.011.003Zm15.406-24.219c.527.98 1.66 7.1-1.435 13.793 0-.214-.02-.429-.023-.64-.026-10.893 1.356-13.349 1.458-13.153Z"
			fill="#fff"
		/>
		<defs>
			<linearGradient
				id="DailyJayLogo_tsx__a"
				x1={50.544}
				y1={101.088}
				x2={50.544}
				y2={0}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#3478DD" />
				<stop offset={1} stopColor="#3BBEEC" />
			</linearGradient>
			<linearGradient
				id="DailyJayLogo_tsx__b"
				x1={-0.17}
				y1={146.043}
				x2={55.701}
				y2={40.838}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#793BEB" />
				<stop offset={1} stopColor="#793BEB" stopOpacity={0} />
			</linearGradient>
		</defs>
	</svg>
);
export default DailyJayLogo;
